

import { RefObject, Dispatch, SetStateAction } from "react";

import { db } from "../firebaseConnection";
import { addDoc, collection, getDocs, query, where, limit, Timestamp, orderBy } from "firebase/firestore";


async function log(lid: String, lpr: String) {

    await addDoc(collection(db, "logs"), {
        id: lid,
        dt_logs: new Date(),
        ds_logs: lpr,
    })

}

export const registerLog = (id: String, parameter: String) => {

    log(id, parameter);
    return;

}

export async function checkExists(colecao: string, campo: string, valor: String) {
    
    try {

    const q = query(collection(db, colecao), where(campo, "==", valor), limit(1));
    const queryclients = await getDocs(q);

        if(queryclients.empty) { return 0; } else { return 1; }
    }
    catch(error) {
        return error;
    }

}

export async function db_basic(idClient: string) {

    try {

        const vigenciaAtual = expiryDate();

        //query clients
        const qClient = query(collection(db, "client"), where("id", "==", idClient), limit(1));

        //query agents
        const qAgent = query(collection(db, "agent"), where("id_client", "==", idClient), orderBy("data_criacao", "desc"), limit(1));

        //executa em paralelo (mais performático)
        const [snapClient, snapAgent] = await Promise.all([getDocs(qClient), getDocs(qAgent)]);

        if (snapClient.empty) {
            throw new Error("Cliente atual não encontrado");
        }

        const clientData = {idDoc: snapClient.docs[0].id, ...snapClient.docs[0].data()};        
        const agentData = snapAgent.empty ? {id: null, status: 0, plano: null} : {id: snapAgent.docs[0].id, ...snapAgent.docs[0].data()};

        return {client: clientData, agent: agentData};

    } catch (error) {
        console.error("Erro em db_basic:", error);
        throw error;
    }
}


export const formatTimestamp = (periodo: any): string | null => {
    
    if (periodo == null) return null;

    // Detecta se é Timestamp do Firebase ou número puro
    const date = periodo.toDate ? periodo.toDate() : new Date(periodo);

    const formatted = date
        .toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        })
        .replace(/\//g, ".");

    return formatted;
    
};


export const expiryDate = () => {

    const v1 = new Date("2100-12-31T23:59:59Z");
    return Timestamp.fromDate(v1);

}

export const firstName = (fullName: string): string => {
    
    if (!fullName) return "";
        const parts = fullName.trim().split(" ");
    
        return parts[0];
        
}

export const statusAgentsPanel = (status: number) => {

    switch(status) {

        case 0:
            return [
                {textButton: "CRIAR AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente não foi criado"},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não criado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não criado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não criado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 1:
            return [
                {textButton: "CONFIGURAR AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente não foi configurado"},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não configurado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não configurado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não configurado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 2:
            return [
                {textButton: "VER AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente não ativado (pendências)"},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não ativado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não ativado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não ativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 3:
            return [
                {textButton: "ALTERAR AGENTE", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: "Agente ativado (período de testes)"},
                {textButton: "VER AGENDA", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "QUERO ASSINAR", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 4:
            return [
                {textButton: "ALTERAR AGENTE", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: "Agente ativado (assinante)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 5:
            return [
                {textButton: "CRIAR OUTRO AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente Desativado (motivo cliente)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "Agente Desativado", textStatus: ""}
            ];

        case 6:
            return [
                {textButton: "CRIAR OUTRO AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente Desativado (falta pagamento)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        default:
            return [];

    }

}


export const textButtonAgent = (status: number) => {

    let resp = "";

    switch(status) {
        case 0:
            resp = "CRIAR AGENTE";
            break;
        case 1:
            resp = "CONFIGURAR AGENTE";
            break;
        case 2:
            resp = "VER CONFIGURAÇÕES"
            break;
        case 3:
            resp = "ALTERAR AGENTE";
            break;
        case 4:
            resp = "ALTERAR AGENTE";
            break;
        default:
            resp = "CRIAR AGENTE";
    }

    return resp;

}

export const titleTextStatusAgent = (status: Number) => {

    let tit, tex = "";

    switch(status) {
        case 0:
            tit = "Crie seu agente";
            tex = "Essas são as configurações básicas para a criação do seu agente, onde você lhe dará um nome e escolherá um plano que mais se adequa as suas necessidades.";
            break;
        case 1:
            tit = "Configure seu agente";
            tex = "Essas são as configurações básicas para a criação do seu agente, onde você lhe dará um nome e escolherá um plano que mais se adequa as suas necessidades.";
            break;
        case 2:
            tit = "Veja seu agente";
            tex = "Seu agente está criado e configurado, entretanto, estamos aguardando a viabilização da técnica para ativá-lo.";
            break;
        case 3:
            tit = "Veja seu agente";
            tex = "Seu agente está criado e configurado, entretanto, estamos resolvendo pendências técnicas para ativá-lo.";
            break;
        case 4:
            tit = "Altere seu agente";
            tex = "Seu agente está criado e configurado e você poderá fazer alterações para melhor atender a sua necessidade.";
            break;
    }

    return {titulo: tit, texto: tex};

}


export const dateDiffDias = (data1: Date, data2: Date) => {

    const diffMs = Math.abs(data2.getTime() - data1.getTime());

    return { dias: Math.floor(diffMs / (1000 * 60 * 60 * 24)), horas: Math.floor(diffMs / (1000 * 60 * 60)) };
    
}

export const levelPassword = (senha: string) => {

        if(senha.length === 0) {
            return "";
        } else {

            let ch1 = /^(?=.*[a-z])/; /* minuscula */
            let ch2 = /(?=.*[A-Z])/; /* maiuscula */
            let ch3 = /(?=.*\d)/; /* digito */
            let ch4 = /(?=.*[@$!%*?&])/; /* caracter especial */

            let t1 = ch1.test(senha);
            let t2 = ch2.test(senha);
            let t3 = ch3.test(senha);
            let t4 = ch4.test(senha);

            let pass = t1.toString().substring(0, 1) + t2.toString().substring(0, 1) + t3.toString().substring(0, 1) + t4.toString().substring(0, 1);

            switch(pass) {
                case "ffff": return "muito fraca"; break;
                case "tfff": return "fraca"; break;
                case "ftff": return "fraca"; break;
                case "fftf": return "fraca"; break;
                case "ffft": return "fraca"; break;
                case "ttff": return "média"; break;
                case "tftf": return "média"; break;
                case "tfft": return "média"; break;
                case "fttf": return "média"; break;
                case "ftft": return "média"; break;
                case "fftt": return "média"; break;
                case "tttf": return "forte"; break;
                case "ttft": return "forte"; break;
                case "tftt": return "forte"; break;
                case "fttt": return "forte"; break;
                default: return "muito forte";
            }
        }
        
    }
    

/* ts scripts para as inputs */

export const showError = <T>(inputRef: RefObject<HTMLInputElement | HTMLTextAreaElement>, labelRef: RefObject<HTMLInputElement>, errorRef: RefObject<HTMLSpanElement>, message: string, setErrorState?: Dispatch<SetStateAction<T>>, errorValue?: T): void => {
  
    if(errorRef?.current) {
        errorRef.current.innerHTML = message;
        errorRef.current.style.height = "1.5rem";
    }

    if(inputRef?.current) {
        inputRef.current.style.backgroundColor = "yellow";
        inputRef.current.focus();
    }

    if(labelRef?.current) {
        labelRef.current.style.borderBottom = "2px solid red";
        if (inputRef.current instanceof HTMLTextAreaElement) {
            labelRef.current.style.backgroundColor = "yellow";
        }
    }

    if(setErrorState && errorValue !== undefined) {
        setErrorState(errorValue);
    }

};

export const clearError = (inputRef: RefObject<HTMLInputElement>, labelRef: RefObject<HTMLInputElement>, errorRef: RefObject<HTMLSpanElement>, errorState: string, setErrorState?: Dispatch<SetStateAction<string>>): void => {

    if(errorState !== "0") {
        if (errorRef?.current) {
            errorRef.current.innerHTML = "";
            errorRef.current.style.height = "0";
        }

        if(inputRef?.current) {
            inputRef.current.style.backgroundColor = "";
        }

        if(labelRef?.current) {
            labelRef.current.style.borderBottom = "";
            if (inputRef.current instanceof HTMLTextAreaElement) {
                labelRef.current.style.backgroundColor = "";
            }
        }

        if (setErrorState) setErrorState("0");
    }
    
};

export const formError = (errorRef: RefObject<HTMLSpanElement>, message: string, mode: boolean): void => {

    if (errorRef?.current) {
        if(mode) {
            errorRef.current.innerHTML = message;
            errorRef.current.style.height = "1.5rem";
        }
        else {
            errorRef.current.innerHTML = "";
            errorRef.current.style.height = "0";
        }
    }
 
};

export const validarCPFouCNPJ = (valor: string): boolean => {
  
    if (!valor) return false;
    const num = valor.replace(/\D/g, "");

    //cpf - 11 dígitos
    if (num.length === 11) {
        if (/^(\d)\1{10}$/.test(num)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(num[i]) * (10 - i);
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(num[9])) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(num[i]) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(num[10]);
    }

    //cnpj - 14 dígitos
    if (num.length === 14) {
        if (/^(\d)\1{13}$/.test(num)) return false;

        let tamanho = 12;
        let numeros = num.substring(0, tamanho);
        const digitos = num.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        tamanho++;
        numeros = num.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));
    }

    return false;

}

export const wait = (ms: number): Promise<void> => { return new Promise(resolve => setTimeout(resolve, ms)); };

export const isValidDate = (value: string): boolean => {

    if (!/^\d{2}\/\d{2}\/\d{2}$/.test(value)) return false;

    const [d, m, y] = value.split('/').map(Number);
    const fullYear = 2000 + y;
    const date = new Date(fullYear, m - 1, d);

    return (
        date.getFullYear() === fullYear &&
        date.getMonth() === m - 1 &&
        date.getDate() === d
    );

};

export const dateToTimestamp = (value: string): Timestamp  | null => {
    
    if (!/^\d{2}\/\d{2}\/(\d{2}|\d{4})$/.test(value)) return null;

    const [d, m, y] = value.split('/').map(Number);
    const fullYear = y < 100 ? 2000 + y : y; // converte "25" → 2025
    const date = new Date(fullYear, m - 1, d);

    // garante que a data gerada é válida
    if (
        date.getFullYear() !== fullYear ||
        date.getMonth() !== m - 1 ||
        date.getDate() !== d
    ) {
        return null;
    }

    return Timestamp.fromDate(date);

};

